// src/helpers.ts
var normalizeEmail = (email) => email?.toLowerCase()?.trim();
var capitalizeEveryWord = (inputString) => {
  return inputString.replace(/\b\w+/g, (match) => {
    return match.charAt(0).toUpperCase() + match.slice(1).toLowerCase();
  });
};

export {
  normalizeEmail,
  capitalizeEveryWord
};
//# sourceMappingURL=chunk-FE7NU5ES.mjs.map